import {_} from 'lodash';
import {template as tpl, viewModel as MutableCustomer} from "./mutable";
import {global} from "../../../appContext";
import {nsCustomerGeneral} from "./fn";
import {ICompany, IRouteDefinitionParams} from "../../../index";
import {CREATING_MESSAGE} from "../../../constants/Language";
import PromiseRequest from "../../../req/PromiseRequest";

export let template: string = tpl;

export class viewModel extends MutableCustomer {

    protected override readonly data: ICompany = _.cloneDeep(nsCustomerGeneral.DefaultValues)
    protected readonly icon: string = 'fa-plus';
    protected readonly label: string = "Opprett kunde";
    protected readonly req_submit: PromiseRequest = global.getPromiseRequest("createcompany");

    protected msg_submitting = CREATING_MESSAGE
    protected msg_success = `subject is created|s:((customer))`

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.initRequest();
    }

    protected override initRequest(): Promise<any> {
        return super.initRequest()
            .then(() => {
                this.init();
                this.messageData(null);
                this.isReady(true);
            });
    }

}